import { generateRequest } from './index';

export const Action = {
  FuelEconomyStats: {
    FetchFuelEconomyStatsPending: 'FetchFuelEconomyStatsPending',
    FetchFuelEconomyStatsCompleted: 'FetchFuelEconomyStatsCompleted',
    FetchFuelEconomyStatsFailed: 'FetchFuelEconomyStatsFailed',
  },
};

export const fetchFuelEconomyStats = vehicleGuid => generateRequest({
  endpoint: `/assets-v2/api/vehicles/${vehicleGuid}/fuel-economy`,
  types: [
    Action.FuelEconomyStats.FetchFuelEconomyStatsPending,
    {
      type: Action.FuelEconomyStats.FetchFuelEconomyStatsCompleted,
      meta: { vehicleGuid },
    },
    Action.FuelEconomyStats.FetchFuelEconomyStatsFailed,
  ],
});
